import React from 'react';

const TermsOfService = () => {
  return (
    <main className="min-h-screen pt-24">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-light mb-6">Terms of Service</h1>
        <div className="text-light/80 space-y-6">
          <p>
            Last updated: March 22, 2025
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Introduction</h2>
          <p>
            These Terms of Service ("Terms") govern your access to and use of the Eluno Consulting website 
            and services. By accessing or using our website, you agree to be bound by these Terms.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Use of Services</h2>
          <p>
            You agree to use our services only for lawful purposes and in accordance with these Terms. 
            You agree not to:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Use our services in any way that violates any applicable laws or regulations</li>
            <li>Use our services to transmit any material that infringes on intellectual property rights</li>
            <li>Interfere with or disrupt our services or servers</li>
            <li>Collect or store personal data about other users without their consent</li>
          </ul>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Intellectual Property</h2>
          <p>
            The content, features, and functionality of our website, including but not limited to text, 
            graphics, logos, and software, are owned by Eluno Consulting and are protected by 
            copyright, trademark, and other intellectual property laws.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Limitation of Liability</h2>
          <p>
            In no event shall Eluno Consulting be liable for any indirect, incidental, special, 
            consequential, or punitive damages, including without limitation, loss of profits, 
            data, use, goodwill, or other intangible losses, resulting from your access to or 
            use of or inability to access or use our services.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Eluno Consulting and its officers, directors, 
            employees, and agents from and against any claims, liabilities, damages, losses, and 
            expenses, including, without limitation, reasonable legal and accounting fees, arising 
            out of or in any way connected with your access to or use of our services or your 
            violation of these Terms.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Changes to Terms</h2>
          <p>
            We may modify these Terms at any time. We will provide notice of any material changes 
            by posting the new Terms on our website. Your continued use of our services after any 
            such changes constitutes your acceptance of the new Terms.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the 
            jurisdiction in which Eluno Consulting operates, without regard to its conflict of 
            law provisions.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p className="mt-2">
            Email: hello@eluno.consulting<br />
            Phone: (816) 678-5415
          </p>
        </div>
      </div>
    </main>
  );
};

export default TermsOfService;